import { render, staticRenderFns } from "./IosSdk.vue?vue&type=template&id=1ddf8b61&scoped=true&"
import script from "./IosSdk.vue?vue&type=script&lang=ts&"
export * from "./IosSdk.vue?vue&type=script&lang=ts&"
import style0 from "./IosSdk.vue?vue&type=style&index=0&id=1ddf8b61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddf8b61",
  null
  
)

export default component.exports